import { Message } from "element-ui"

const DEFAULT_NOT_BUY_MSG = "暂无权限"

export function onTip(isFlag, is_member_by, context, not_buy_msg) {
  if (!context.$store.getters.token) {
    context.$router.pushToTab("/login")
    return true
  }
  const msg = not_buy_msg || DEFAULT_NOT_BUY_MSG
  if (!isFlag) {
    Message.error(msg)
    return true
  } else if (!is_member_by) {
    Message.error(msg)
    return true
  }
  else {
    return false
  }
}
